export const LANG_MAP = {
  zh_CN: {
    login_with_phone: '手机号登录',
    login_with_email: '邮箱登录',
    login_success: '登录成功',
    login_success_description: '你已成功登录game_name，请返回游戏查看',
    login_fail: '登录失败',
    login_fail_timeout: '当前登录页面已过期，请返回game_name重试',
    login_fail_invalid: '当前登录页面已失效，请返回game_name重试',
    enter_your_phone_number: '输入您的手机号码',
    enter_email: '输入您的邮箱',
    invalid_phone: '请输入有效的手机号码',
    invalid_email: '请输入有效的电子邮箱',
    incorrect_code: '请输入正确的验证码。',
    log_in: '登录',
    verify: '验证',
    retry: '重试',
    search: '搜索',
    phone_number: '手机号码',
    email: '电子邮箱',
    send_to: '发送至',
    enter_the_code: '输入验证码',
    send_a_code: '发送验证码',
    code_sent: '验证码已发送',
    fill_verification_code: '请填写验证码',
    user_agreement: '用户协议',
    privacy_policy: '隐私政策',
  },
  zh_TW: {
    login_with_phone: '手機號登錄',
    login_with_email: '電子郵箱登入',
    login_success: '登入成功',
    login_success_description: '您已經成功登入game_name，請返回遊戲查看',
    login_fail: '登入失敗',
    login_fail_timeout: '當前登入頁面已過期，請返回game_name重試',
    login_fail_invalid: '目前登錄頁面已失效，請回到game_name重試',
    enter_your_phone_number: '請輸入您的電話號碼',
    enter_email: '輸入您的電子郵件地址',
    invalid_phone: '請輸入有效的手機號碼',
    invalid_email: '請輸入有效的電子郵箱',
    incorrect_code: '請輸入正確的驗證碼',
    log_in: '登入',
    verify: '驗證',
    retry: '重試',
    search: '搜尋',
    phone_number: '手機號碼',
    email: '電子郵箱',
    send_to: '送信先',
    enter_the_code: '輸入驗證碼',
    send_a_code: '發送驗證碼',
    code_sent: '驗證碼已發送',
    fill_verification_code: '請填寫驗證碼',
    user_agreement: '用戶協議',
    privacy_policy: '隱私政策',
  },
  en_US: {
    login_with_phone: 'Log in with Phone Number',
    login_with_email: 'Log in with Email',
    login_success: 'Login Succeeded',
    login_success_description: 'You have successfully logged into game_name, please return to the game to check',
    login_fail: 'Login Failed',
    login_fail_timeout: 'The current login page has expired, please return to game_name to try again',
    login_fail_invalid: 'The current login page is no longer available, please return to game_name to try again',
    enter_your_phone_number: 'Enter your phone number',
    enter_email: 'Enter your email address',
    invalid_phone: 'Please enter a valid mobile phone number',
    invalid_email: 'Please enter a valid email address',
    incorrect_code: 'Please enter the correct verification code',
    log_in: 'Log in',
    verify: 'Verify',
    retry: 'Retry',
    search: 'Search',
    phone_number: 'Phone number',
    email: 'Email',
    send_to: 'Send to',
    enter_the_code: 'Enter the code',
    send_a_code: 'Send a code',
    code_sent: 'A verification code has been sent.',
    fill_verification_code: 'Please enter the verification code',
    user_agreement: 'User Agreement',
    privacy_policy: 'Privacy Policy',
  },
  ja_JP: {
    login_with_phone: '電話番号でログイン',
    login_with_email: 'メールでログイン',
    login_success: 'ログインに成功しました',
    login_success_description: 'game_name へのログインに成功しました。ゲームに戻ってご確認ください。',
    login_fail: 'ログインに失敗しました',
    login_fail_timeout: 'ログイン期限が切れました。 game_name に戻って再度お試しください',
    login_fail_invalid: 'ログインの有効期限が切れました。 game_name に戻って再度お試しください',
    enter_your_phone_number: '電話番号を入力',
    enter_email: 'メールアドレスを入力',
    invalid_phone: '有効な電話番号を入力してください',
    invalid_email: '有効なメールアドレスを入力してください',
    incorrect_code: '正しい確認コードを入力してください',
    log_in: 'ログイン',
    verify: '確認',
    retry: '再試行',
    search: '検索',
    phone_number: '電話番号',
    email: 'メールアドレス',
    send_to: '送信先',
    enter_the_code: 'コードを入力',
    send_a_code: 'コードを送信',
    code_sent: '確認コードが送信されました',
    fill_verification_code: '確認コードを入力してください',
    user_agreement: '利用規約',
    privacy_policy: 'プライバシーポリシー',
  },
  ko_KR: {
    login_with_phone: '전화번호로 로그인',
    login_with_email: '이메일로 로그인하기',
    login_success: '로그인 성공',
    login_success_description: '성공적으로 game_name 에 로그인하였습니다. 게임으로 돌아가 확인하세요.',
    login_fail: '로그인 실패',
    login_fail_timeout: '현재 로그인 페이지가 만료되었습니다. game_name 에 돌아간 뒤 다시 시도하세요.',
    login_fail_invalid: '현재 로그인 페이지가 비활성화되었습니다. game_name 에 돌아간 뒤 다시 시도하세요.',
    enter_your_phone_number: '전화번호를 입력하세요',
    enter_email: '이메일 주소를 입력하세요',
    invalid_phone: '유효한 핸드폰 번호를 입력해 주세요',
    invalid_email: '유효한 이메일 주소를 입력해주세요',
    incorrect_code: '정확한 인증 코드를 입력해 주세요',
    log_in: '로그인',
    verify: '확인하기',
    retry: '다시 시도',
    search: '검색',
    phone_number: '휴대폰 번호',
    email: '이메일',
    send_to: '발송하기',
    enter_the_code: '코드를 입력하세요',
    send_a_code: '코드 보내기',
    code_sent: '인증 코드가 전송되었습니다.',
    fill_verification_code: '인증 코드를 입력해 주세요',
    user_agreement: '사용자 계약서',
    privacy_policy: '개인정보 처리방침',
  },
  th_TH: {
    login_with_phone: 'เข้าสู่ระบบด้วยหมายเลขโทรศัพท์',
    login_with_email: 'เข้าสู่ระบบด้วยอีเมล',
    login_success: 'ล็อกอินสำเร็จ',
    login_success_description: 'คุณได้ล็อกอิน game_name ให้สำเร็จแล้ว กรุณากลับเกมเพื่อเช็คดู',
    login_fail: 'ล็อกอินลมเหลว',
    login_fail_timeout: 'หน้าล็อกอินของปัจจุบันนี้หมดอายุแล้ว กรุณากลับ game_name เพื่อลองใหม่',
    login_fail_invalid: 'หน้าล็อกอินของปัจจุบันนี้ไม่ถูกต้อง กรุณากลับ game_name เพื่อลองใหม่',
    enter_your_phone_number: 'ป้อนหมายเลขโทรศัพท์ของคุณ',
    enter_email: 'กรอกที่อยู่อีเมล์ของคุณ',
    invalid_phone: 'กรอกข้อมูลที่ถูกต้อง',
    invalid_email: 'กรอกข้อมูลที่ถูกต้อง',
    incorrect_code: 'ข้อมูลผิดพลาด',
    log_in: 'เข้าสู่ระบบ',
    verify: 'ตรวจสอบ',
    retry: 'ลองใหม่',
    search: 'ค้นหา',
    phone_number: 'หมายเลขโทรศัพท์มือถือ',
    email: 'อีเมล',
    send_to: 'ส่งถึง',
    enter_the_code: 'ใส่รหัส',
    send_a_code: 'ส่งรหัส',
    code_sent: 'รหัสยืนยันได้ถูกส่งแล้ว',
    fill_verification_code: 'กรุณากรอกรหัสยืนยัน',
    user_agreement: 'ข้อตกลงการใช้งาน',
    privacy_policy: 'นโยบายความเป็นส่วนตัว',
  },
  id_ID: {
    login_with_phone: 'Masuk Dengan Nomor Telepon',
    login_with_email: 'Masuk dengan Email',
    login_success: 'Login berhasil',
    login_success_description: 'Anda telah berhasil masuk ke game_name. Harap kembalikan game untuk diperiksa.',
    login_fail: 'Gagal masuk',
    login_fail_timeout: 'Halaman login saat ini telah kedaluwarsa. Harap kembalikan game_name untuk mencoba lagi.',
    login_fail_invalid: 'Halaman login saat ini tidak valid. Harap kembalikan game_name untuk mencoba lagi.',
    enter_your_phone_number: 'Masukkan nomor telepon Anda',
    enter_email: 'Masukkan alamat email Anda',
    invalid_phone: 'Isi informasi yang valid',
    invalid_email: 'Isi informasi yang valid',
    incorrect_code: 'Kesalahan informasi',
    log_in: 'Masuk',
    verify: 'Verifikasi',
    retry: 'Coba Lagi',
    search: 'Temukan',
    phone_number: 'Nomor Ponsel',
    email: 'Email',
    send_to: 'Kirim ke',
    enter_the_code: 'Masukkan kode',
    send_a_code: 'Kirimkan kode',
    code_sent: 'Kode verifikasi telah dikirim.',
    fill_verification_code: 'Silakan isi kode verifikasi',
    user_agreement: 'Perjanjian Pengguna',
    privacy_policy: 'Kebijakan Privasi',
  },
  in_ID: {
    login_with_phone: 'Masuk Dengan Nomor Telepon',
    login_with_email: 'Masuk dengan Email',
    login_success: 'Login berhasil',
    login_success_description: 'Anda telah berhasil masuk ke game_name. Harap kembalikan game untuk diperiksa.',
    login_fail: 'Gagal masuk',
    login_fail_timeout: 'Halaman login saat ini telah kedaluwarsa. Harap kembalikan game_name untuk mencoba lagi.',
    login_fail_invalid: 'Halaman login saat ini tidak valid. Harap kembalikan game_name untuk mencoba lagi.',
    enter_your_phone_number: 'Masukkan nomor telepon Anda',
    enter_email: 'Masukkan alamat email Anda',
    invalid_phone: 'Isi informasi yang valid',
    invalid_email: 'Isi informasi yang valid',
    incorrect_code: 'Kesalahan informasi',
    log_in: 'Masuk',
    verify: 'Verifikasi',
    retry: 'Coba Lagi',
    search: 'Temukan',
    phone_number: 'Nomor Ponsel',
    email: 'Email',
    send_to: 'Kirim ke',
    enter_the_code: 'Masukkan kode',
    send_a_code: 'Kirimkan kode',
    code_sent: 'Kode verifikasi telah dikirim.',
    fill_verification_code: 'Silakan isi kode verifikasi',
    user_agreement: 'Perjanjian Pengguna',
    privacy_policy: 'Kebijakan Privasi',
  },
  vi_VN: {
    login_with_phone: 'Đăng nhập bằng số điện thoại',
    login_with_email: 'Đăng nhập bằng email',
    login_success: 'Đăng nhập thành công',
    login_success_description: 'Bạn đã đăng nhập game_name thành công, vui lòng quay lại trò chơi để xem',
    login_fail: 'Đăng nhập thất bại',
    login_fail_timeout: 'Trang đăng nhập hiện tại đã hết hạn. Vui lòng quay lại game_name để thử lại.',
    login_fail_invalid: 'Trang đăng nhập hiện tại không hợp lệ.Vui lòng quay lại game_name để thử lại.',
    enter_your_phone_number: 'Nhập số điện thoại của bạn',
    enter_email: 'Nhập địa chỉ email của bạn',
    invalid_phone: 'điền thông tin hợp lệ',
    invalid_email: 'điền thông tin hợp lệ',
    incorrect_code: 'Thông tin sai',
    log_in: 'Đăng nhập',
    verify: 'Xác minh',
    retry: 'Thử lại',
    search: 'Tìm kiếm',
    phone_number: 'Số điện thoại di động',
    email: 'Email',
    send_to: 'Gửi đến',
    enter_the_code: 'Nhập mã code',
    send_a_code: 'Gửi mã',
    code_sent: 'Mã xác nhận đã được gửi.',
    fill_verification_code: 'Vui lòng điền mã xác minh',
    user_agreement: 'Thỏa thuận người dùng',
    privacy_policy: 'Chính sách bảo mật',
  },
  es_ES: {
    login_with_phone: 'Iniciar sesión con número de teléfono',
    login_with_email: 'Iniciar sesión con correo electrónico',
    login_success: 'Iniciado sesión con éxito',
    login_success_description: 'Has iniciado sesión con éxito en game_name. Vuelve al juego para verificarlo.',
    login_fail: 'Error al iniciar sesión',
    login_fail_timeout: 'Página de inicio de sesión actual caducada, vuelve a game_name e inténtalo de nuevo',
    login_fail_invalid: 'Página de inicio de sesión actual inválida, vuelve a game_name e inténtalo de nuevo',
    enter_your_phone_number: 'Ingresa tu número de teléfono',
    enter_email: 'Ingresa tu dirección de correo electrónico',
    invalid_phone: 'Complete información válida',
    invalid_email: 'Complete información válida',
    incorrect_code: 'Error en la información',
    log_in: 'Iniciar sesión',
    verify: 'Verificar',
    retry: 'Reintentar',
    search: 'Buscar',
    phone_number: 'número de teléfono móvil',
    email: 'Correo electrónico',
    send_to: 'Enviar a',
    enter_the_code: 'Ingresa el código',
    send_a_code: 'Envía un código',
    code_sent: 'Se ha enviado un código de verificación.',
    fill_verification_code: 'Por favor, ingrese el código de verificación',
    user_agreement: 'User Agreement',
    privacy_policy: 'Privacy Policy',
  },
  pt_PT: {
    login_with_phone: 'Entrar com número de telefone',
    login_with_email: 'Entrar com Email',
    login_success: 'Login com sucesso',
    login_success_description: 'Você fez login com sucesso em game_name. Por favor, volte ao jogo para verificar.',
    login_fail: 'Falha em login',
    login_fail_timeout: 'A interface de login atual expirou. Retorne game_name e tente novamente',
    login_fail_invalid: 'A interface de login atual é inválida. Retorne game_name e tente novamente',
    enter_your_phone_number: 'Insira o seu número de telefone',
    enter_email: 'Digite seu endereço de email',
    invalid_phone: 'Preencha informações válidas',
    invalid_email: 'Preencha informações válidas',
    incorrect_code: 'Erro nas informações',
    log_in: 'Entrar',
    verify: 'Verificar',
    retry: 'Tentar novamente',
    search: 'Pesquisar',
    phone_number: 'Número de celular',
    email: 'E-mail',
    send_to: 'Enviar para',
    enter_the_code: 'Insira o código',
    send_a_code: 'Envie um código',
    code_sent: 'Um código de verificação foi enviado.',
    fill_verification_code: 'Por favor, preencha o código de verificação',
    user_agreement: "Contrat d'utilisateur",
    privacy_policy: 'Politique de Confidentialité',
  },
  fr: {
    login_with_phone: 'Se connecter avec un numéro de téléphone',
    login_with_email: "Se connecter avec l'email",
    login_success: 'Connexion réussie',
    login_success_description:
      'Vous vous êtes connecté avec succès à game_name, veuillez retourner au jeu pour vérifier.',
    login_fail: 'Connexion échouée',
    login_fail_timeout: 'La page de connexion actuelle a expiré, veuillez retourner à game_name pour réessayer.',
    login_fail_invalid:
      "La page de connexion actuelle n'est plus disponible, veuillez retourner à game_name pour réessayer.",
    enter_your_phone_number: 'Entrez votre numéro de téléphone',
    enter_email: 'Saisissez votre adresse e-mail',
    invalid_phone: 'Remplissez des informations valides',
    invalid_email: 'Remplissez des informations valides',
    incorrect_code: "Erreur d'information",
    log_in: 'Connexion',
    verify: 'Vérifier',
    retry: 'Réessayer',
    search: 'Recherche',
    phone_number: 'Numéro de téléphone mobile',
    email: 'E-mail',
    send_to: 'Envoyer à',
    enter_the_code: 'Entrez le code',
    send_a_code: 'Envoyer un code',
    code_sent: 'Un code de vérification a été envoyé.',
    fill_verification_code: 'Veuillez remplir le code de vérification',
    user_agreement: "Contrat d'utilisateur",
    privacy_policy: 'Politique de Confidentialité',
  },
  fr_FR: {
    login_with_phone: 'Se connecter avec un numéro de téléphone',
    login_with_email: "Se connecter avec l'email",
    login_success: 'Connexion réussie',
    login_success_description:
      'Vous vous êtes connecté avec succès à game_name, veuillez retourner au jeu pour vérifier.',
    login_fail: 'Connexion échouée',
    login_fail_timeout: 'La page de connexion actuelle a expiré, veuillez retourner à game_name pour réessayer.',
    login_fail_invalid:
      "La page de connexion actuelle n'est plus disponible, veuillez retourner à game_name pour réessayer.",
    enter_your_phone_number: 'Entrez votre numéro de téléphone',
    enter_email: 'Saisissez votre adresse e-mail',
    invalid_phone: 'Remplissez des informations valides',
    invalid_email: 'Remplissez des informations valides',
    incorrect_code: "Erreur d'information",
    log_in: 'Connexion',
    verify: 'Vérifier',
    retry: 'Réessayer',
    search: 'Recherche',
    phone_number: 'Numéro de téléphone mobile',
    email: 'E-mail',
    send_to: 'Envoyer à',
    enter_the_code: 'Entrez le code',
    send_a_code: 'Envoyer un code',
    code_sent: 'Un code de vérification a été envoyé.',
    fill_verification_code: 'Veuillez remplir le code de vérification',
    user_agreement: "Contrat d'utilisateur",
    privacy_policy: 'Politique de Confidentialité',
  },
  de: {
    login_with_phone: 'Mit Telefonnummer anmelden',
    login_with_email: 'Mit E-Mail anmelden',
    login_success: 'Login erfolgreich',
    login_success_description: 'Du hast dich erfolgreich in game_name eingeloggt, bitte zum Spiel zurückkehren.',
    login_fail: 'Login fehlgeschlagen',
    login_fail_timeout:
      'Die aktuelle Login-Seite ist abgelaufen. Bitte kehre zu game_name zurück und versuch es erneut',
    login_fail_invalid:
      'Die aktuelle Login-Seite ist nicht mehr verfügbar. Bitte kehre zu game_name zurück und versuch es erneut',
    enter_your_phone_number: 'Gib deine Telefonnummer ein',
    enter_email: 'Geben Sie Ihre E-Mail-Adresse ein',
    invalid_phone: 'Geben Sie gültige Informationen ein',
    invalid_email: 'Geben Sie gültige Informationen ein',
    incorrect_code: 'Fehlerhafte Informationen',
    log_in: 'Einloggen',
    verify: 'Überprüfen',
    retry: 'Wiederholen',
    search: 'Suche',
    phone_number: 'Handynummer',
    email: 'E-Mail',
    send_to: 'Senden an',
    enter_the_code: 'Gib den Code ein',
    send_a_code: 'Sende einen Code',
    code_sent: 'Ein Verifizierungscode wurde gesendet.',
    fill_verification_code: 'Bitte geben Sie den Bestätigungscode ein',
    user_agreement: 'Nutzervereinbarung',
    privacy_policy: 'Datenschutzrichtlinie',
  },
  de_DE: {
    login_with_phone: 'Mit Telefonnummer anmelden',
    login_with_email: 'Mit E-Mail anmelden',
    login_success: 'Login erfolgreich',
    login_success_description: 'Du hast dich erfolgreich in game_name eingeloggt, bitte zum Spiel zurückkehren.',
    login_fail: 'Login fehlgeschlagen',
    login_fail_timeout:
      'Die aktuelle Login-Seite ist abgelaufen. Bitte kehre zu game_name zurück und versuch es erneut',
    login_fail_invalid:
      'Die aktuelle Login-Seite ist nicht mehr verfügbar. Bitte kehre zu game_name zurück und versuch es erneut',
    enter_your_phone_number: 'Gib deine Telefonnummer ein',
    enter_email: 'Geben Sie Ihre E-Mail-Adresse ein',
    invalid_phone: 'Geben Sie gültige Informationen ein',
    invalid_email: 'Geben Sie gültige Informationen ein',
    incorrect_code: 'Fehlerhafte Informationen',
    log_in: 'Einloggen',
    verify: 'Überprüfen',
    retry: 'Wiederholen',
    search: 'Suche',
    phone_number: 'Handynummer',
    email: 'E-Mail',
    send_to: 'Senden an',
    enter_the_code: 'Gib den Code ein',
    send_a_code: 'Sende einen Code',
    code_sent: 'Ein Verifizierungscode wurde gesendet.',
    fill_verification_code: 'Bitte geben Sie den Bestätigungscode ein',
    user_agreement: 'Nutzervereinbarung',
    privacy_policy: 'Datenschutzrichtlinie',
  },
  tr: {
    login_with_phone: 'Telefon Numarası ile Giriş Yap',
    login_with_email: 'E-posta ile Giriş Yap',
    login_success: 'Giriş Yapıldı',
    login_success_description: 'Giriş yaptınız game_name, Oyuna dönüp inceleyiniz',
    login_fail: 'Giriş Başarısız',
    login_fail_timeout: 'Mevcut giriş sayfasının süresi doldu, lütfen game_name oyununa geri dönün ve tekrar deneyin.',
    login_fail_invalid:
      'Mevcut giriş sayfası artık kullanılamıyor, lütfen game_name oyununa geri dönün ve tekrar deneyin.',
    enter_your_phone_number: 'Telefon numaranızı girin',
    enter_email: 'E-posta adresinizi girin',
    invalid_phone: 'Geçerli bilgi girin',
    invalid_email: 'Geçerli bilgi girin',
    incorrect_code: 'Hatalı bilgi',
    log_in: 'Oturum aç',
    verify: 'Doğrula',
    retry: 'Tekrar Dene',
    search: 'Arama',
    phone_number: 'Cep Telefonu Numarası',
    email: 'E-posta',
    send_to: 'Gönder:',
    enter_the_code: 'Kodu girin',
    send_a_code: 'Bir kod gönder',
    code_sent: 'Bir doğrulama kodu gönderildi.',
    fill_verification_code: 'Lütfen doğrulama kodunu girin',
    user_agreement: 'Kullanıcı Sözleşmesi',
    privacy_policy: 'Gizlilik Politikası',
  },
  tr_TR: {
    login_with_phone: 'Telefon Numarası ile Giriş Yap',
    login_with_email: 'E-posta ile Giriş Yap',
    login_success: 'Giriş Yapıldı',
    login_success_description: 'Giriş yaptınız game_name, Oyuna dönüp inceleyiniz',
    login_fail: 'Giriş Başarısız',
    login_fail_timeout: 'Mevcut giriş sayfasının süresi doldu, lütfen game_name oyununa geri dönün ve tekrar deneyin.',
    login_fail_invalid:
      'Mevcut giriş sayfası artık kullanılamıyor, lütfen game_name oyununa geri dönün ve tekrar deneyin.',
    enter_your_phone_number: 'Telefon numaranızı girin',
    enter_email: 'E-posta adresinizi girin',
    invalid_phone: 'Geçerli bilgi girin',
    invalid_email: 'Geçerli bilgi girin',
    incorrect_code: 'Hatalı bilgi',
    log_in: 'Oturum aç',
    verify: 'Doğrula',
    retry: 'Tekrar Dene',
    search: 'Arama',
    phone_number: 'Cep Telefonu Numarası',
    email: 'E-posta',
    send_to: 'Gönder:',
    enter_the_code: 'Kodu girin',
    send_a_code: 'Bir kod gönder',
    code_sent: 'Bir doğrulama kodu gönderildi.',
    fill_verification_code: 'Lütfen doğrulama kodunu girin',
    user_agreement: 'Kullanıcı Sözleşmesi',
    privacy_policy: 'Gizlilik Politikası',
  },
  ru: {
    login_with_phone: 'Войти с номером телефона',
    login_with_email: 'Войти с помощью электронной почты',
    login_success: 'Вход успешен',
    login_success_description: 'Вы успешно вошли в игру game_name, вернитесь в игру, чтобы просмотреть',
    login_fail: 'Вход не удался',
    login_fail_timeout: 'Текущая страница входа просрочена, вернитесь в игру game_name и попробуйте снова',
    login_fail_invalid: 'Текущая страница входа уже недействительна, вернитесь в игру game_name и попробуйте снова',
    enter_your_phone_number: 'Введите ваш номер телефона',
    enter_email: 'Введите свой адрес электронной почты',
    invalid_phone: 'Заполните действительную информацию',
    invalid_email: 'Заполните действительную информацию',
    incorrect_code: 'Ошибка информации',
    log_in: 'Вход в систему',
    verify: 'Проверить',
    retry: 'Повторить',
    search: 'Поиск',
    phone_number: 'Номер мобильного телефона',
    email: 'Электронная почта',
    send_to: 'Отправить в',
    enter_the_code: 'Введите код',
    send_a_code: 'Отправьте код',
    code_sent: 'Код подтверждения был отправлен.',
    fill_verification_code: 'Пожалуйста, введите код подтверждения',
    user_agreement: 'Пользовательское Соглашение',
    privacy_policy: 'Политика конфиденциальности',
  },
  ru_RU: {
    login_with_phone: 'Войти с номером телефона',
    login_with_email: 'Войти с помощью электронной почты',
    login_success: 'Вход успешен',
    login_success_description: 'Вы успешно вошли в игру game_name, вернитесь в игру, чтобы просмотреть',
    login_fail: 'Вход не удался',
    login_fail_timeout: 'Текущая страница входа просрочена, вернитесь в игру game_name и попробуйте снова',
    login_fail_invalid: 'Текущая страница входа уже недействительна, вернитесь в игру game_name и попробуйте снова',
    enter_your_phone_number: 'Введите ваш номер телефона',
    enter_email: 'Введите свой адрес электронной почты',
    invalid_phone: 'Заполните действительную информацию',
    invalid_email: 'Заполните действительную информацию',
    incorrect_code: 'Ошибка информации',
    log_in: 'Вход в систему',
    verify: 'Проверить',
    retry: 'Повторить',
    search: 'Поиск',
    phone_number: 'Номер мобильного телефона',
    email: 'Электронная почта',
    send_to: 'Отправить в',
    enter_the_code: 'Введите код',
    send_a_code: 'Отправьте код',
    code_sent: 'Код подтверждения был отправлен.',
    fill_verification_code: 'Пожалуйста, введите код подтверждения',
    user_agreement: 'Пользовательское Соглашение',
    privacy_policy: 'Политика конфиденциальности',
  },
};
